import * as React from "react";
import {useCallback} from "react";
import {classNames, CodeForm, layout, View, ViewContent} from "@variocube/cube-ui";
import {AccessLevel, Controller} from "../controller/Controller";
import {useLocalization} from "../../i18n";

interface AuthenticationViewProps {
    onCancel: () => void;
    onAccess: (level: AccessLevel) => void;
    controller: Controller;
}

export function AuthenticationView({controller, onCancel, onAccess}: AuthenticationViewProps) {
    const {t} = useLocalization();

    const handleVerify = useCallback(async (code: string) => {
        const {accessLevel} = await controller.verifyAuthCode(code);
        onAccess(accessLevel);
    }, [controller, onAccess]);

    return (
        <View>
            <ViewContent className={classNames(layout.vertical, layout.center)}>
                <CodeForm
                    className={layout.spaceEvenly}
                    onVerify={handleVerify}
                    onCancel={onCancel}
                    strings={t}
                />
            </ViewContent>
        </View>
    )
}
